import { ActionReducerMap } from '@ngrx/store';
import { AppState } from '../appState/app.state';
import { userReducer } from '../user/user.reducer';
import { userMenuListReducer } from '../userMenuList/userMenuList.reducer';
import { universalFilterReducer } from '../universalFilter/universal-filter.reducer';
import { appContextReducer } from '../appContext/app-context.reducer';
import { pagelevelFilterReducer } from '../pagelevel-filter/pagelevel-filter.reducer';

export const appReducers: ActionReducerMap<AppState> = {
  user: userReducer,
  menuList: userMenuListReducer,
  universalFilter: universalFilterReducer,
  appContext: appContextReducer,
  pagelevelFilter: pagelevelFilterReducer,
};
